import type { ComplianceColorBand } from '@/shared/types/SharedProps'

export type ComplianceFilter = 'all' | 'high' | 'medium' | 'low' | 'none'

const DEFAULT_COLOR_BANDS: ComplianceColorBand[] = [
  { minRange: 90, maxRange: 100, color: '#DFFEE0' },
  { minRange: 80, maxRange: 89, color: '#F9D295' },
  { minRange: 0, maxRange: 79, color: '#FDBAB9' },
]

export function complianceBgColor(
  percent: number | null | undefined,
  colorCodes: ComplianceColorBand[] | null | undefined,
): string {
  if (percent == null) return '#E5E7EB'
  const bands = colorCodes?.length ? colorCodes : DEFAULT_COLOR_BANDS
  const band = bands.find((b) => percent >= b.minRange && percent <= b.maxRange)
  return band?.color ?? '#E5E7EB'
}

// Kept for backwards-compat — remove once all callers migrated
export function complianceHexColor(
  percent: number | null | undefined,
  colorCodes: ComplianceColorBand[] | null | undefined,
): string {
  return complianceBgColor(percent, colorCodes)
}

export function formatCompliancePercent(percent: number | null | undefined): string {
  if (percent == null) return '—'
  return `${Math.round(percent)}%`
}

export function matchesComplianceFilter(
  percent: number | null | undefined,
  filter: ComplianceFilter,
): boolean {
  if (filter === 'all') return true
  if (filter === 'none') return percent == null
  if (percent == null) return false
  if (filter === 'high') return percent >= 90
  if (filter === 'medium') return percent >= 80 && percent < 90
  if (filter === 'low') return percent < 80
  return true
}
